export default __webpack_public_path__ + "static/media/exampleImage2.7f7404d7.jpg";